import { connectIdSchema } from "../organiser";
import { z } from "zod";

export const addCollaboratorSchema = z
  .object({
    roleId: z.string(),
    connectId: connectIdSchema,
    email: z.union([z.string().email(), z.literal("")]),
  })
  .superRefine((data, ctx) => {
    if (!data.connectId && !data.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["connectId"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["email"],
      });
    }
  });

export const defaultAddCollaboratorValues = {
  role: "",
  connectId: "",
  email: "",
};

export type AddCollaboratorForm = z.infer<typeof addCollaboratorSchema>;
